import { render, staticRenderFns } from "./justification-picker.vue?vue&type=template&id=14c6e268&scoped=true&"
import script from "./justification-picker.vue?vue&type=script&lang=js&"
export * from "./justification-picker.vue?vue&type=script&lang=js&"
import style0 from "./justification-picker.vue?vue&type=style&index=0&id=14c6e268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c6e268",
  null
  
)

/* custom blocks */
import block0 from "./justification-picker.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports